import { gql, QueryHookOptions, QueryResult, useQuery } from '@apollo/client'

export interface Data {
  setting?: string
}

export interface Variables {
  name: string
}

export const QUERY = gql`
  query getSystemSettingValueByName($name: ID!) {
    setting: getSystemSettingValueByName(name: $name)
  }
`

export const useSystemSettingValueQuery = (
  data?: QueryHookOptions<Data, Variables>,
): QueryResult<Data, Variables> => useQuery<Data, Variables>(QUERY, data)
